import { memo } from "react";
import "./Text.scss";

const Text = memo((props) => {
  const { type, text, fontSize, className = "", bold, size, children, ...restProps } = props;

  const isBold = bold || type === "semi-bold";
  const fontWeightClass = isBold ? "fw-bold" : "";
  const sizeClass = size === "large" ? "fs-5" : "";
  const combinedClassName = `${fontWeightClass} ${sizeClass} ${className}`.trim();

  // If text is provided, we use dangerouslySetInnerHTML to maintain backward compatibility
  // with parts of the codebase that pass raw HTML strings.
  // Otherwise, we render standard children.
  const renderContent = () => {
    if (text !== undefined && text !== null) {
      return { dangerouslySetInnerHTML: { __html: text } };
    }
    return { children };
  };

  const render = () => {
    const contentProps = renderContent();

    switch (type) {
      case "h1":
        return (
          <h1
            style={fontSize ? { fontSize: `var(${fontSize})` } : {}}
            className={combinedClassName}
            {...contentProps}
            {...restProps}
          />
        );
      case "h2":
        return (
          <h2
            style={fontSize ? { fontSize: `var(${fontSize})` } : {}}
            className={combinedClassName}
            {...contentProps}
            {...restProps}
          />
        );
      case "h3":
        return <h3 className={combinedClassName} {...contentProps} {...restProps} />;
      case "h4":
        return <h4 className={combinedClassName} {...contentProps} {...restProps} />;
      case "h5":
        return <h5 className={combinedClassName} {...contentProps} {...restProps} />;
      case "h6":
        return <h6 className={combinedClassName} {...contentProps} {...restProps} />;
      case "h7":
        return <p className={`h7 ${combinedClassName}`} {...contentProps} {...restProps} />;
      case "t-icon":
        return (
          <p className={`d-flex align-items-center gap-2 ${combinedClassName}`} {...restProps}>
            {props?.tIcon}
            {text !== undefined && text !== null ? (
              <span dangerouslySetInnerHTML={{ __html: text }} />
            ) : (
              children
            )}
          </p>
        );
      case "small":
        return (
          <small
            style={{ display: "block" }}
            className={combinedClassName}
            {...contentProps}
            {...restProps}
          />
        );
      case "span":
        return <span className={combinedClassName} {...contentProps} {...restProps} />;
      case "semi-bold":
        return (
          <p className={`h7 fw-semibold ${combinedClassName}`} {...contentProps} {...restProps} />
        );
      default:
        return <p className={combinedClassName} {...contentProps} {...restProps} />;
    }
  };

  return <>{render()}</>;
});

export default Text;
